import Vue from "vue";

/**
 * Global scroll lock directive
 */
Vue.directive("scroll-lock", {
  /**
   * When the directive is attached, then lock the scroll
   */
  bind() {
    // Step 1: Get to the top
    window.scrollTo(0, 0);

    // Step 2: Lock the scroll
    document.querySelector("html").style.overflow = "hidden";
    document.querySelector("body").style.overflow = "hidden";
  },
  /**
   * When the directive is unattached, then we remove the scroll lock
   */
  unbind() {
    // Start scroll again
    document.querySelector("html").style.removeProperty("overflow");
    document.querySelector("body").style.removeProperty("overflow");
  }
});

Vue.directive('focus-on-load', {
    inserted: function (el) {
        el.focus();
    }
})